import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ProfilePictureService {
	private readonly beUrl = environment.baseUrl.replace(/\/$/, '');
	private readonly defaultImage = 'assets/images/portrait/small/avatar-s.jpg';

	getProfilePictureUrl(profilePicture: string | null | undefined): string {
		if (!profilePicture || profilePicture.endsWith('/') || profilePicture === 'profile-picture/###user_id###/filename.extension') {
			return this.defaultImage;
		}

		if (profilePicture.startsWith('http://') || profilePicture.startsWith('https://')) {
			return profilePicture;
		}

		if (profilePicture.startsWith('/storage/')) {
			return `${this.beUrl}${profilePicture}`;
		}

		if (profilePicture.startsWith('storage/')) {
			return `${this.beUrl}/${profilePicture}`;
		}

		return `${this.beUrl}/storage/${profilePicture}`;
	}

	getDefaultProfilePictureUrl(): string {
		return this.defaultImage;
	}
}
